import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '../material/material.module';
import { SuccessDialogComponent } from './success-dialog/success-dialog.component';
import { ErrorDialogComponent } from './payment-error-dialog/error-dialog.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { LazyloaderComponent } from './lazyloader/lazyloader.component';
import { FreshLoaderComponent } from './fresh-loader/fresh-loader.component';
import { SearchLoaderComponent } from './search-loader/search-loader.component';
import { IdCardErrorDialogComponent } from './idCard-error-dialog/idCard-dialog.component';
import { NoImageNotifyDialogComponent } from './no-image-notify-dialog/no-image-notify-dialog.component';
import { OopsDialogComponent } from './oops-dialog/oops-dialog.component';
import { NoSchoolFeesPaidDialogComponent } from './no-school-fees-paid-dialog/no-school-fees-paid-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { StaffOnlyOopsDialogComponent } from './staff-only-oops-dialog/staff-only-oops-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ConfirmLogoutDialogComponent } from './confirm-logout-dialog/confirm-logout-dialog.component';
import { PortraitCaptureAlertDialogComponent } from './portrait-capture-alert-dialog/portrait.capture.alert.dialog.component';
import { PortraitCaptureHintCardComponent } from './portrait-capture-hint-card/portrait.capture.hint.card.component';

@NgModule({
  declarations: [
    SuccessDialogComponent,
    ErrorDialogComponent,
    IdCardErrorDialogComponent,
    NoImageNotifyDialogComponent,
    OopsDialogComponent,
    StaffOnlyOopsDialogComponent,
    NoSchoolFeesPaidDialogComponent,
    NotFoundComponent,
    LazyloaderComponent,
    FreshLoaderComponent,
    SearchLoaderComponent,
    PageLoaderComponent,
    ConfirmDialogComponent,
    AlertDialogComponent,
    PortraitCaptureAlertDialogComponent,
    ConfirmLogoutDialogComponent,
    PortraitCaptureHintCardComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    SuccessDialogComponent,
    ErrorDialogComponent,
    NoImageNotifyDialogComponent,
    OopsDialogComponent,
    StaffOnlyOopsDialogComponent,
    NoSchoolFeesPaidDialogComponent,
    NotFoundComponent,
    LazyloaderComponent,
    FreshLoaderComponent,
    SearchLoaderComponent,
    IdCardErrorDialogComponent,
    PageLoaderComponent,
    ConfirmDialogComponent,
    AlertDialogComponent,
    PortraitCaptureAlertDialogComponent,
    ConfirmLogoutDialogComponent,
    PortraitCaptureHintCardComponent
  ],
  entryComponents: [
    SuccessDialogComponent,
    ErrorDialogComponent,
    IdCardErrorDialogComponent,
    NoImageNotifyDialogComponent,
    OopsDialogComponent,
    StaffOnlyOopsDialogComponent,
    NoSchoolFeesPaidDialogComponent,
    PageLoaderComponent,
    ConfirmDialogComponent,
    AlertDialogComponent,
    PortraitCaptureAlertDialogComponent,
    ConfirmLogoutDialogComponent,
    PortraitCaptureHintCardComponent
  ]
})
export class SharedModule {}